// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmReassignmentPopup-module__font-s-10___pNa68 {
  font-size: 10px !important;
}

.ConfirmReassignmentPopup-module__font-s-12___chG7y {
  font-size: 12px !important;
}

.ConfirmReassignmentPopup-module__font-s-13___DSr6B {
  font-size: 13px !important;
}

.ConfirmReassignmentPopup-module__font-s-14___si1aV {
  font-size: 14px !important;
}

.ConfirmReassignmentPopup-module__font-s-15___qEjKG {
  font-size: 15px !important;
}

.ConfirmReassignmentPopup-module__font-s-16___VZJje {
  font-size: 16px !important;
}

.ConfirmReassignmentPopup-module__font-s-18___Wpl6G {
  font-size: 18px !important;
}

.ConfirmReassignmentPopup-module__font-s-20___hfWTI {
  font-size: 20px !important;
}

.ConfirmReassignmentPopup-module__font-s-22___QweCH {
  font-size: 22px !important;
}

.ConfirmReassignmentPopup-module__font-s-28___W9AMN {
  font-size: 28px !important;
}

.ConfirmReassignmentPopup-module__font-w-400___u2AHJ {
  font-weight: 400 !important;
}

.ConfirmReassignmentPopup-module__font-w-500___RKx99 {
  font-weight: 500 !important;
}

.ConfirmReassignmentPopup-module__font-w-600___bJ_Ks {
  font-weight: 600 !important;
}

.ConfirmReassignmentPopup-module__font-w-700___TaRiM {
  font-weight: 700 !important;
}

.ConfirmReassignmentPopup-module__p-5___JcoTX {
  padding: 5px !important;
}

.ConfirmReassignmentPopup-module__p-12___u_mGE {
  padding: 12px !important;
}

.ConfirmReassignmentPopup-module__p-16___yuOPN {
  padding: 16px !important;
}

.ConfirmReassignmentPopup-module__p-30___xbm7A {
  padding: 30px !important;
}

.ConfirmReassignmentPopup-module__p-b-0___xcutZ {
  padding-bottom: 0 !important;
}

.ConfirmReassignmentPopup-module__p-b-5___yWWd4 {
  padding-bottom: 5px !important;
}

.ConfirmReassignmentPopup-module__p-b-10___uzPn7 {
  padding-bottom: 10px !important;
}

.ConfirmReassignmentPopup-module__p-b-12___TM4uZ {
  padding-bottom: 12px !important;
}

.ConfirmReassignmentPopup-module__p-b-16___Vy8ys {
  padding-bottom: 16px !important;
}

.ConfirmReassignmentPopup-module__p-b-18___YjkQH {
  padding-bottom: 18px !important;
}

.ConfirmReassignmentPopup-module__p-b-20___p0zgI {
  padding-bottom: 20px !important;
}

.ConfirmReassignmentPopup-module__p-b-25___Tnk4f {
  padding-bottom: 25px !important;
}

.ConfirmReassignmentPopup-module__p-b-30___kJHDf {
  padding-bottom: 30px !important;
}

.ConfirmReassignmentPopup-module__p-b-50___dhs0g {
  padding-bottom: 50px !important;
}

.ConfirmReassignmentPopup-module__p-t-0___oQR_O {
  padding-top: 0 !important;
}

.ConfirmReassignmentPopup-module__p-t-12___vqVe0 {
  padding-top: 12px !important;
}

.ConfirmReassignmentPopup-module__p-t-16___qQ0O8 {
  padding-top: 16px !important;
}

.ConfirmReassignmentPopup-module__p-t-18___grBDc {
  padding-top: 18px !important;
}

.ConfirmReassignmentPopup-module__p-t-20___SEDKp {
  padding-top: 20px !important;
}

.ConfirmReassignmentPopup-module__p-t-30___corff {
  padding-top: 30px !important;
}

.ConfirmReassignmentPopup-module__p-t-40___VQjdI {
  padding-top: 40px !important;
}

.ConfirmReassignmentPopup-module__p-t-50___svbf8 {
  padding-top: 50px !important;
}

.ConfirmReassignmentPopup-module__p-l-20___nrJAo {
  padding-left: 20px !important;
}

.ConfirmReassignmentPopup-module__p-l-30___hSbVW {
  padding-left: 30px !important;
}

.ConfirmReassignmentPopup-module__p-l-40___MhuE_ {
  padding-left: 40px !important;
}

.ConfirmReassignmentPopup-module__p-r-16___j6254 {
  padding-right: 16px !important;
}

.ConfirmReassignmentPopup-module__p-r-20___w5c9i {
  padding-right: 20px !important;
}

.ConfirmReassignmentPopup-module__p-r-30___iwSP8 {
  padding-right: 30px !important;
}

.ConfirmReassignmentPopup-module__p-r-50___GaBXa {
  padding-right: 50px !important;
}

.ConfirmReassignmentPopup-module__p-r-60___zHAFz {
  padding-right: 60px !important;
}

.ConfirmReassignmentPopup-module__m-b-1___FtwhV {
  margin-bottom: 1px !important;
}

.ConfirmReassignmentPopup-module__m-b-2___ivYtZ {
  margin-bottom: 2px !important;
}

.ConfirmReassignmentPopup-module__m-b-6___mwiJx {
  margin-bottom: 6px !important;
}

.ConfirmReassignmentPopup-module__m-b-8___FGglL {
  margin-bottom: 8px !important;
}

.ConfirmReassignmentPopup-module__m-b-10___XxaLV {
  margin-bottom: 10px !important;
}

.ConfirmReassignmentPopup-module__m-b-14___IoAdH {
  margin-bottom: 14px !important;
}

.ConfirmReassignmentPopup-module__m-b-16___B0EST {
  margin-bottom: 16px !important;
}

.ConfirmReassignmentPopup-module__m-b-20___XbCA_ {
  margin-bottom: 20px !important;
}

.ConfirmReassignmentPopup-module__m-b-22___Ihvm6 {
  margin-bottom: 22px !important;
}

.ConfirmReassignmentPopup-module__m-b-24___zpfDJ {
  margin-bottom: 24px !important;
}

.ConfirmReassignmentPopup-module__m-b-30___vk0fj {
  margin-bottom: 30px !important;
}

.ConfirmReassignmentPopup-module__m-b-32___PJv2X {
  margin-bottom: 32px !important;
}

.ConfirmReassignmentPopup-module__m-b-40___E3MN2 {
  margin-bottom: 40px !important;
}

.ConfirmReassignmentPopup-module__m-t-2___U3OdW {
  margin-top: 2px !important;
}

.ConfirmReassignmentPopup-module__m-t-3___B4aC9 {
  margin-top: 3px !important;
}

.ConfirmReassignmentPopup-module__m-t-4___xL5xz {
  margin-top: 4px !important;
}

.ConfirmReassignmentPopup-module__m-t-5___ffqCl {
  margin-top: 5px !important;
}

.ConfirmReassignmentPopup-module__m-t-8___jC6Rt {
  margin-top: 8px !important;
}

.ConfirmReassignmentPopup-module__m-t-10___KFlEP {
  margin-top: 10px !important;
}

.ConfirmReassignmentPopup-module__m-t-15___OnseG {
  margin-top: 15px !important;
}

.ConfirmReassignmentPopup-module__m-t-16___YMIaK {
  margin-top: 16px !important;
}

.ConfirmReassignmentPopup-module__m-t-20___dAz1p {
  margin-top: 20px !important;
}

.ConfirmReassignmentPopup-module__m-t-22___IJo9b {
  margin-top: 22px !important;
}

.ConfirmReassignmentPopup-module__m-t-30___vsqcH {
  margin-top: 30px !important;
}

.ConfirmReassignmentPopup-module__m-t-32___sMc7M {
  margin-top: 32px !important;
}

.ConfirmReassignmentPopup-module__m-l-auto___momg9 {
  margin-left: auto !important;
}

.ConfirmReassignmentPopup-module__m-l-4___Ze2zA {
  margin-left: 4px !important;
}

.ConfirmReassignmentPopup-module__m-l-5___FPGOl {
  margin-left: 5px !important;
}

.ConfirmReassignmentPopup-module__m-l-6___C4WyX {
  margin-left: 6px !important;
}

.ConfirmReassignmentPopup-module__m-l-8___A1JcP {
  margin-left: 8px !important;
}

.ConfirmReassignmentPopup-module__m-l-10___i5d1E {
  margin-left: 10px !important;
}

.ConfirmReassignmentPopup-module__m-l-16___KxkUz {
  margin-left: 16px !important;
}

.ConfirmReassignmentPopup-module__m-l-20___VNNzD {
  margin-left: 20px !important;
}

.ConfirmReassignmentPopup-module__m-l-24___OcsTU {
  margin-left: 24px !important;
}

.ConfirmReassignmentPopup-module__m-l-30___qcrh8 {
  margin-left: 30px !important;
}

.ConfirmReassignmentPopup-module__m-l-35___joSyP {
  margin-left: 35px !important;
}

.ConfirmReassignmentPopup-module__m-l-40___ZhCMq {
  margin-left: 40px !important;
}

.ConfirmReassignmentPopup-module__m-r-8___qEvE1 {
  margin-right: 8px !important;
}

.ConfirmReassignmentPopup-module__m-r-10___ctNR6 {
  margin-right: 10px !important;
}

.ConfirmReassignmentPopup-module__m-r-16___GJrFk {
  margin-right: 16px !important;
}

.ConfirmReassignmentPopup-module__m-r-20___uAoyb {
  margin-right: 20px !important;
}

.ConfirmReassignmentPopup-module__m-r-24___qN_on {
  margin-right: 24px !important;
}

.ConfirmReassignmentPopup-module__m-r-30___k8hFA {
  margin-right: 30px !important;
}

.ConfirmReassignmentPopup-module__m-r-40___GhHdC {
  margin-right: 40px !important;
}

.ConfirmReassignmentPopup-module__border-r-3___de8aJ {
  border-radius: 3px !important;
}

.ConfirmReassignmentPopup-module__border-r-4___xGQYr {
  border-radius: 4px !important;
}

.ConfirmReassignmentPopup-module__border-r-6___X2mq8 {
  border-radius: 6px !important;
}

.ConfirmReassignmentPopup-module__border-r-10___tlx8I {
  border-radius: 10px !important;
}

.ConfirmReassignmentPopup-module__border-r-12___AHhP7 {
  border-radius: 12px !important;
}

.ConfirmReassignmentPopup-module__border-r-16___nziFJ {
  border-radius: 16px !important;
}

.ConfirmReassignmentPopup-module__border-r-50___N0tSx {
  border-radius: 50% !important;
}

.ConfirmReassignmentPopup-module__primary-border___Z0IS2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ConfirmReassignmentPopup-module__primary-border-b___y2DEB {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ConfirmReassignmentPopup-module__primary-border-t___vuZvf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ConfirmReassignmentPopup-module__primary-border-l___MF5sP {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ConfirmReassignmentPopup-module__primary-border-r___dEeKA {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ConfirmReassignmentPopup-module__secondary-border___awZse {
  border: 1px solid #637768;
}

.ConfirmReassignmentPopup-module__secondary-border-b___mrUWB {
  border-bottom: 1px solid #637768;
}

.ConfirmReassignmentPopup-module__secondary-border-t___cwH9V {
  border-top: 1px solid #637768;
}

.ConfirmReassignmentPopup-module__secondary-border-l___DXnQr {
  border-left: 1px solid #637768;
}

.ConfirmReassignmentPopup-module__secondary-border-r___GKf9c {
  border-right: 1px solid #637768;
}

.ConfirmReassignmentPopup-module__gap-0___lC4ao {
  gap: 0 !important;
}

.ConfirmReassignmentPopup-module__gap-2___OmAsL {
  gap: 2px !important;
}

.ConfirmReassignmentPopup-module__gap-4___yqFWv {
  gap: 4px !important;
}

.ConfirmReassignmentPopup-module__gap-5___OpJfQ {
  gap: 5px !important;
}

.ConfirmReassignmentPopup-module__gap-6___D0rDL {
  gap: 6px !important;
}

.ConfirmReassignmentPopup-module__gap-8___Fgyu_ {
  gap: 8px !important;
}

.ConfirmReassignmentPopup-module__gap-10___CucgO {
  gap: 10px !important;
}

.ConfirmReassignmentPopup-module__gap-12___td_p9 {
  gap: 12px !important;
}

.ConfirmReassignmentPopup-module__gap-14___aPwuE {
  gap: 14px !important;
}

.ConfirmReassignmentPopup-module__gap-16___swqCt {
  gap: 16px !important;
}

.ConfirmReassignmentPopup-module__gap-18___jkdA2 {
  gap: 18px !important;
}

.ConfirmReassignmentPopup-module__gap-20___Hk3T9 {
  gap: 20px !important;
}

.ConfirmReassignmentPopup-module__gap-24___OmKZC {
  gap: 24px !important;
}

.ConfirmReassignmentPopup-module__gap-26___EqAPF {
  gap: 26px !important;
}

.ConfirmReassignmentPopup-module__gap-30___T8Ao6 {
  gap: 30px !important;
}

.ConfirmReassignmentPopup-module__gap-32___Dc_LL {
  gap: 32px !important;
}

.ConfirmReassignmentPopup-module__gap-40____ix0Q {
  gap: 40px !important;
}

.ConfirmReassignmentPopup-module__gap-50___Rsm_F {
  gap: 50px !important;
}

.ConfirmReassignmentPopup-module__flex-1___iDGI_ {
  flex: 1;
}

.ConfirmReassignmentPopup-module__flex-none___pDdIv {
  flex: none !important;
}

.ConfirmReassignmentPopup-module__flex-column___C0Lrx {
  display: flex;
  flex-direction: column !important;
}

.ConfirmReassignmentPopup-module__flex-row___IyiK2 {
  display: flex;
  flex-direction: row !important;
}

.ConfirmReassignmentPopup-module__vertically-centered___OV3q5 {
  display: flex;
  align-items: center !important;
}

.ConfirmReassignmentPopup-module__horizontally-centered___fjRQt {
  display: flex;
  justify-content: center !important;
}

.ConfirmReassignmentPopup-module__horizontally-end___CNPUb {
  display: flex;
  justify-content: end !important;
}

.ConfirmReassignmentPopup-module__vertically-start___aVB6v {
  display: flex;
  align-items: start !important;
}

.ConfirmReassignmentPopup-module__space-between___Hi1V2 {
  display: flex;
  justify-content: space-between !important;
}

.ConfirmReassignmentPopup-module__flex-wrap___gd7x3 {
  flex-wrap: wrap !important;
}

.ConfirmReassignmentPopup-module__height-100___vltZv {
  height: 100%;
}

.ConfirmReassignmentPopup-module__width-50___SPz6B {
  width: 50% !important;
}

.ConfirmReassignmentPopup-module__width-100___c5ZJN {
  width: 100%;
}

.ConfirmReassignmentPopup-module__cursor-pointer___khkP6 {
  cursor: pointer;
}

.ConfirmReassignmentPopup-module__cursor-not-allowed___ET4bl {
  cursor: not-allowed !important;
}

.ConfirmReassignmentPopup-module__absolute-centered___VeoIU {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ConfirmReassignmentPopup-module__absolute___kBw5A {
  position: absolute;
}

.ConfirmReassignmentPopup-module__relative___rn5le {
  position: relative;
}

.ConfirmReassignmentPopup-module__fixed___MK_Fs {
  position: fixed;
}

.ConfirmReassignmentPopup-module__visible___ADu69 {
  opacity: 1;
}

.ConfirmReassignmentPopup-module__invisible___o887e {
  opacity: 0;
}

.ConfirmReassignmentPopup-module__col-90___UX7D0 {
  width: 90% !important;
}

.ConfirmReassignmentPopup-module__col-auto___Z84P9 {
  width: auto !important;
}

.ConfirmReassignmentPopup-module__medical-tabs___Dpwus {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ConfirmReassignmentPopup-module__medical-table-new___G9hOU {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU::-webkit-scrollbar-track {
  display: none;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU.ConfirmReassignmentPopup-module__no-pagination___MW5kl {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU.ConfirmReassignmentPopup-module__no-pagination___MW5kl:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU.ConfirmReassignmentPopup-module__no-pagination___MW5kl::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ConfirmReassignmentPopup-module__medical-table-new___G9hOU.ConfirmReassignmentPopup-module__no-pagination___MW5kl::-webkit-scrollbar-track {
  display: none;
}

.ConfirmReassignmentPopup-module__medical-table-empty___LHBLG {
  padding: 14px 40px !important;
}

.ConfirmReassignmentPopup-module__icon-btn___TxdIm {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ConfirmReassignmentPopup-module__search-icon___Vc8N8 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ConfirmReassignmentPopup-module__disable-select___eGYma {
  user-select: none;
}

.ConfirmReassignmentPopup-module__break-word___u48gJ {
  word-break: break-word;
}

.ConfirmReassignmentPopup-module__popup-clear-btn___r9JAh {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ConfirmReassignmentPopup-module__scroll-m-b-20___aeXv9 {
  scroll-margin-bottom: 20px;
}

.ConfirmReassignmentPopup-module__header___v4qs8 {
  justify-content: space-between;
  padding: 50px 20px 30px 50px;
}
.ConfirmReassignmentPopup-module__header___v4qs8 .ConfirmReassignmentPopup-module__title___RR8y_ {
  font-family: var(--font-family);
  font-weight: 700;
  color: #17335b;
  font-size: 24px;
}

.ConfirmReassignmentPopup-module__subtitle___Gw9Sz {
  width: 30vw;
  font-family: var(--font-family);
  font-weight: 400;
  color: #17335b;
  padding: 0 50px 30px 50px;
}

.ConfirmReassignmentPopup-module__buttonsContainer___TnZQy {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
  padding: 20px 40px 40px 40px;
}
.ConfirmReassignmentPopup-module__buttonsContainer___TnZQy .ConfirmReassignmentPopup-module__button___S6UED {
  width: 12vw;
  margin: 0 1vw;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ConfirmReassignmentPopup/ConfirmReassignmentPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;EACA,4BAAA;AA8pBF;AA5pBE;EEoBA,+BApBO;EAqBP,gBCtBK;EHGH,cAAA;EACA,eAAA;AA+pBJ;;AA3pBA;EACE,WAAA;EEYA,+BApBO;EAqBP,gBCzBQ;EHcR,cAAA;EACA,yBAAA;AA+pBF;;AA5pBA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,uBAAA;EACA,4BAAA;AA+pBF;AA7pBE;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  justify-content: space-between;\n  padding: 50px 20px 30px 50px;\n\n  .title {\n    @include get-font($roboto, $bold);\n    color: get-color(blue, dark);\n    font-size: 24px;\n  }\n}\n\n.subtitle {\n  width: 30vw;\n  @include get-font($roboto, $regular);\n  color: get-color(blue, dark);\n  padding: 0 50px 30px 50px;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  justify-content: center;\n  padding: 20px 40px 40px 40px;\n\n  .button {\n    width: 12vw;\n    margin: 0 1vw;\n    cursor: pointer;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ConfirmReassignmentPopup-module__font-s-10___pNa68`,
	"fontS12": `ConfirmReassignmentPopup-module__font-s-12___chG7y`,
	"fontS13": `ConfirmReassignmentPopup-module__font-s-13___DSr6B`,
	"fontS14": `ConfirmReassignmentPopup-module__font-s-14___si1aV`,
	"fontS15": `ConfirmReassignmentPopup-module__font-s-15___qEjKG`,
	"fontS16": `ConfirmReassignmentPopup-module__font-s-16___VZJje`,
	"fontS18": `ConfirmReassignmentPopup-module__font-s-18___Wpl6G`,
	"fontS20": `ConfirmReassignmentPopup-module__font-s-20___hfWTI`,
	"fontS22": `ConfirmReassignmentPopup-module__font-s-22___QweCH`,
	"fontS28": `ConfirmReassignmentPopup-module__font-s-28___W9AMN`,
	"fontW400": `ConfirmReassignmentPopup-module__font-w-400___u2AHJ`,
	"fontW500": `ConfirmReassignmentPopup-module__font-w-500___RKx99`,
	"fontW600": `ConfirmReassignmentPopup-module__font-w-600___bJ_Ks`,
	"fontW700": `ConfirmReassignmentPopup-module__font-w-700___TaRiM`,
	"p5": `ConfirmReassignmentPopup-module__p-5___JcoTX`,
	"p12": `ConfirmReassignmentPopup-module__p-12___u_mGE`,
	"p16": `ConfirmReassignmentPopup-module__p-16___yuOPN`,
	"p30": `ConfirmReassignmentPopup-module__p-30___xbm7A`,
	"pB0": `ConfirmReassignmentPopup-module__p-b-0___xcutZ`,
	"pB5": `ConfirmReassignmentPopup-module__p-b-5___yWWd4`,
	"pB10": `ConfirmReassignmentPopup-module__p-b-10___uzPn7`,
	"pB12": `ConfirmReassignmentPopup-module__p-b-12___TM4uZ`,
	"pB16": `ConfirmReassignmentPopup-module__p-b-16___Vy8ys`,
	"pB18": `ConfirmReassignmentPopup-module__p-b-18___YjkQH`,
	"pB20": `ConfirmReassignmentPopup-module__p-b-20___p0zgI`,
	"pB25": `ConfirmReassignmentPopup-module__p-b-25___Tnk4f`,
	"pB30": `ConfirmReassignmentPopup-module__p-b-30___kJHDf`,
	"pB50": `ConfirmReassignmentPopup-module__p-b-50___dhs0g`,
	"pT0": `ConfirmReassignmentPopup-module__p-t-0___oQR_O`,
	"pT12": `ConfirmReassignmentPopup-module__p-t-12___vqVe0`,
	"pT16": `ConfirmReassignmentPopup-module__p-t-16___qQ0O8`,
	"pT18": `ConfirmReassignmentPopup-module__p-t-18___grBDc`,
	"pT20": `ConfirmReassignmentPopup-module__p-t-20___SEDKp`,
	"pT30": `ConfirmReassignmentPopup-module__p-t-30___corff`,
	"pT40": `ConfirmReassignmentPopup-module__p-t-40___VQjdI`,
	"pT50": `ConfirmReassignmentPopup-module__p-t-50___svbf8`,
	"pL20": `ConfirmReassignmentPopup-module__p-l-20___nrJAo`,
	"pL30": `ConfirmReassignmentPopup-module__p-l-30___hSbVW`,
	"pL40": `ConfirmReassignmentPopup-module__p-l-40___MhuE_`,
	"pR16": `ConfirmReassignmentPopup-module__p-r-16___j6254`,
	"pR20": `ConfirmReassignmentPopup-module__p-r-20___w5c9i`,
	"pR30": `ConfirmReassignmentPopup-module__p-r-30___iwSP8`,
	"pR50": `ConfirmReassignmentPopup-module__p-r-50___GaBXa`,
	"pR60": `ConfirmReassignmentPopup-module__p-r-60___zHAFz`,
	"mB1": `ConfirmReassignmentPopup-module__m-b-1___FtwhV`,
	"mB2": `ConfirmReassignmentPopup-module__m-b-2___ivYtZ`,
	"mB6": `ConfirmReassignmentPopup-module__m-b-6___mwiJx`,
	"mB8": `ConfirmReassignmentPopup-module__m-b-8___FGglL`,
	"mB10": `ConfirmReassignmentPopup-module__m-b-10___XxaLV`,
	"mB14": `ConfirmReassignmentPopup-module__m-b-14___IoAdH`,
	"mB16": `ConfirmReassignmentPopup-module__m-b-16___B0EST`,
	"mB20": `ConfirmReassignmentPopup-module__m-b-20___XbCA_`,
	"mB22": `ConfirmReassignmentPopup-module__m-b-22___Ihvm6`,
	"mB24": `ConfirmReassignmentPopup-module__m-b-24___zpfDJ`,
	"mB30": `ConfirmReassignmentPopup-module__m-b-30___vk0fj`,
	"mB32": `ConfirmReassignmentPopup-module__m-b-32___PJv2X`,
	"mB40": `ConfirmReassignmentPopup-module__m-b-40___E3MN2`,
	"mT2": `ConfirmReassignmentPopup-module__m-t-2___U3OdW`,
	"mT3": `ConfirmReassignmentPopup-module__m-t-3___B4aC9`,
	"mT4": `ConfirmReassignmentPopup-module__m-t-4___xL5xz`,
	"mT5": `ConfirmReassignmentPopup-module__m-t-5___ffqCl`,
	"mT8": `ConfirmReassignmentPopup-module__m-t-8___jC6Rt`,
	"mT10": `ConfirmReassignmentPopup-module__m-t-10___KFlEP`,
	"mT15": `ConfirmReassignmentPopup-module__m-t-15___OnseG`,
	"mT16": `ConfirmReassignmentPopup-module__m-t-16___YMIaK`,
	"mT20": `ConfirmReassignmentPopup-module__m-t-20___dAz1p`,
	"mT22": `ConfirmReassignmentPopup-module__m-t-22___IJo9b`,
	"mT30": `ConfirmReassignmentPopup-module__m-t-30___vsqcH`,
	"mT32": `ConfirmReassignmentPopup-module__m-t-32___sMc7M`,
	"mLAuto": `ConfirmReassignmentPopup-module__m-l-auto___momg9`,
	"mL4": `ConfirmReassignmentPopup-module__m-l-4___Ze2zA`,
	"mL5": `ConfirmReassignmentPopup-module__m-l-5___FPGOl`,
	"mL6": `ConfirmReassignmentPopup-module__m-l-6___C4WyX`,
	"mL8": `ConfirmReassignmentPopup-module__m-l-8___A1JcP`,
	"mL10": `ConfirmReassignmentPopup-module__m-l-10___i5d1E`,
	"mL16": `ConfirmReassignmentPopup-module__m-l-16___KxkUz`,
	"mL20": `ConfirmReassignmentPopup-module__m-l-20___VNNzD`,
	"mL24": `ConfirmReassignmentPopup-module__m-l-24___OcsTU`,
	"mL30": `ConfirmReassignmentPopup-module__m-l-30___qcrh8`,
	"mL35": `ConfirmReassignmentPopup-module__m-l-35___joSyP`,
	"mL40": `ConfirmReassignmentPopup-module__m-l-40___ZhCMq`,
	"mR8": `ConfirmReassignmentPopup-module__m-r-8___qEvE1`,
	"mR10": `ConfirmReassignmentPopup-module__m-r-10___ctNR6`,
	"mR16": `ConfirmReassignmentPopup-module__m-r-16___GJrFk`,
	"mR20": `ConfirmReassignmentPopup-module__m-r-20___uAoyb`,
	"mR24": `ConfirmReassignmentPopup-module__m-r-24___qN_on`,
	"mR30": `ConfirmReassignmentPopup-module__m-r-30___k8hFA`,
	"mR40": `ConfirmReassignmentPopup-module__m-r-40___GhHdC`,
	"borderR3": `ConfirmReassignmentPopup-module__border-r-3___de8aJ`,
	"borderR4": `ConfirmReassignmentPopup-module__border-r-4___xGQYr`,
	"borderR6": `ConfirmReassignmentPopup-module__border-r-6___X2mq8`,
	"borderR10": `ConfirmReassignmentPopup-module__border-r-10___tlx8I`,
	"borderR12": `ConfirmReassignmentPopup-module__border-r-12___AHhP7`,
	"borderR16": `ConfirmReassignmentPopup-module__border-r-16___nziFJ`,
	"borderR50": `ConfirmReassignmentPopup-module__border-r-50___N0tSx`,
	"primaryBorder": `ConfirmReassignmentPopup-module__primary-border___Z0IS2`,
	"primaryBorderB": `ConfirmReassignmentPopup-module__primary-border-b___y2DEB`,
	"primaryBorderT": `ConfirmReassignmentPopup-module__primary-border-t___vuZvf`,
	"primaryBorderL": `ConfirmReassignmentPopup-module__primary-border-l___MF5sP`,
	"primaryBorderR": `ConfirmReassignmentPopup-module__primary-border-r___dEeKA`,
	"secondaryBorder": `ConfirmReassignmentPopup-module__secondary-border___awZse`,
	"secondaryBorderB": `ConfirmReassignmentPopup-module__secondary-border-b___mrUWB`,
	"secondaryBorderT": `ConfirmReassignmentPopup-module__secondary-border-t___cwH9V`,
	"secondaryBorderL": `ConfirmReassignmentPopup-module__secondary-border-l___DXnQr`,
	"secondaryBorderR": `ConfirmReassignmentPopup-module__secondary-border-r___GKf9c`,
	"gap0": `ConfirmReassignmentPopup-module__gap-0___lC4ao`,
	"gap2": `ConfirmReassignmentPopup-module__gap-2___OmAsL`,
	"gap4": `ConfirmReassignmentPopup-module__gap-4___yqFWv`,
	"gap5": `ConfirmReassignmentPopup-module__gap-5___OpJfQ`,
	"gap6": `ConfirmReassignmentPopup-module__gap-6___D0rDL`,
	"gap8": `ConfirmReassignmentPopup-module__gap-8___Fgyu_`,
	"gap10": `ConfirmReassignmentPopup-module__gap-10___CucgO`,
	"gap12": `ConfirmReassignmentPopup-module__gap-12___td_p9`,
	"gap14": `ConfirmReassignmentPopup-module__gap-14___aPwuE`,
	"gap16": `ConfirmReassignmentPopup-module__gap-16___swqCt`,
	"gap18": `ConfirmReassignmentPopup-module__gap-18___jkdA2`,
	"gap20": `ConfirmReassignmentPopup-module__gap-20___Hk3T9`,
	"gap24": `ConfirmReassignmentPopup-module__gap-24___OmKZC`,
	"gap26": `ConfirmReassignmentPopup-module__gap-26___EqAPF`,
	"gap30": `ConfirmReassignmentPopup-module__gap-30___T8Ao6`,
	"gap32": `ConfirmReassignmentPopup-module__gap-32___Dc_LL`,
	"gap40": `ConfirmReassignmentPopup-module__gap-40____ix0Q`,
	"gap50": `ConfirmReassignmentPopup-module__gap-50___Rsm_F`,
	"flex1": `ConfirmReassignmentPopup-module__flex-1___iDGI_`,
	"flexNone": `ConfirmReassignmentPopup-module__flex-none___pDdIv`,
	"flexColumn": `ConfirmReassignmentPopup-module__flex-column___C0Lrx`,
	"flexRow": `ConfirmReassignmentPopup-module__flex-row___IyiK2`,
	"verticallyCentered": `ConfirmReassignmentPopup-module__vertically-centered___OV3q5`,
	"horizontallyCentered": `ConfirmReassignmentPopup-module__horizontally-centered___fjRQt`,
	"horizontallyEnd": `ConfirmReassignmentPopup-module__horizontally-end___CNPUb`,
	"verticallyStart": `ConfirmReassignmentPopup-module__vertically-start___aVB6v`,
	"spaceBetween": `ConfirmReassignmentPopup-module__space-between___Hi1V2`,
	"flexWrap": `ConfirmReassignmentPopup-module__flex-wrap___gd7x3`,
	"height100": `ConfirmReassignmentPopup-module__height-100___vltZv`,
	"width50": `ConfirmReassignmentPopup-module__width-50___SPz6B`,
	"width100": `ConfirmReassignmentPopup-module__width-100___c5ZJN`,
	"cursorPointer": `ConfirmReassignmentPopup-module__cursor-pointer___khkP6`,
	"cursorNotAllowed": `ConfirmReassignmentPopup-module__cursor-not-allowed___ET4bl`,
	"absoluteCentered": `ConfirmReassignmentPopup-module__absolute-centered___VeoIU`,
	"absolute": `ConfirmReassignmentPopup-module__absolute___kBw5A`,
	"relative": `ConfirmReassignmentPopup-module__relative___rn5le`,
	"fixed": `ConfirmReassignmentPopup-module__fixed___MK_Fs`,
	"visible": `ConfirmReassignmentPopup-module__visible___ADu69`,
	"invisible": `ConfirmReassignmentPopup-module__invisible___o887e`,
	"col90": `ConfirmReassignmentPopup-module__col-90___UX7D0`,
	"colAuto": `ConfirmReassignmentPopup-module__col-auto___Z84P9`,
	"medicalTabs": `ConfirmReassignmentPopup-module__medical-tabs___Dpwus`,
	"medicalTableNew": `ConfirmReassignmentPopup-module__medical-table-new___G9hOU`,
	"noPagination": `ConfirmReassignmentPopup-module__no-pagination___MW5kl`,
	"medicalTableEmpty": `ConfirmReassignmentPopup-module__medical-table-empty___LHBLG`,
	"iconBtn": `ConfirmReassignmentPopup-module__icon-btn___TxdIm`,
	"searchIcon": `ConfirmReassignmentPopup-module__search-icon___Vc8N8`,
	"disableSelect": `ConfirmReassignmentPopup-module__disable-select___eGYma`,
	"breakWord": `ConfirmReassignmentPopup-module__break-word___u48gJ`,
	"popupClearBtn": `ConfirmReassignmentPopup-module__popup-clear-btn___r9JAh`,
	"scrollMB20": `ConfirmReassignmentPopup-module__scroll-m-b-20___aeXv9`,
	"header": `ConfirmReassignmentPopup-module__header___v4qs8`,
	"title": `ConfirmReassignmentPopup-module__title___RR8y_`,
	"subtitle": `ConfirmReassignmentPopup-module__subtitle___Gw9Sz`,
	"buttonsContainer": `ConfirmReassignmentPopup-module__buttonsContainer___TnZQy`,
	"button": `ConfirmReassignmentPopup-module__button___S6UED`
};
module.exports = ___CSS_LOADER_EXPORT___;
